import React from "react";
import { Meals as MealsModule } from "../../modules";
import useFrontStore from "../../FrontStore";
import { Container } from "@mui/joy";

const Meals = (props) => {
	const { eventDatas } = useFrontStore.useContainer();
	return (
		<Container maxWidth="md" sx={{ p: 0 }}>
			<MealsModule {...eventDatas} />
		</Container>
	);
};

export default Meals;
